/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaMateriale } from '@models';

@Pipe({
    name: 'anagraficaMateriale',
})
export class AnagraficaMaterialePipe implements PipeTransform {

    transform(value: number, items: AnagraficaMateriale[]) {
        return items.find(i => i.id === value)?.descrizione || '';
    }

}
